import { render, staticRenderFns } from "./EditTherapy.vue?vue&type=template&id=ca397f0c&"
import script from "./EditTherapy.vue?vue&type=script&lang=js&"
export * from "./EditTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports